<template>
  <div class="text-textColor overflow-y-auto">
    <transition name="fade">
      <div
        v-if="showAttachments"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-full overflow-y-auto w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full h-screen"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <div
            class="flex justify-right align-right items-center border-b-1.5 p-3"
          >
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <template>
            <div class="m-2">
              <p class="text-base font-bold">
                {{ docTitle ? docTitle : "Leave Attachments" }}
              </p>
            </div>

            <div class="overflow-y-auto">
              <div>
                <iframe
                  :src="
                    attachmentUrl.startsWith('blob:')
                      ? attachmentUrl
                      : 'data:application/pdf;base64,' + attachmentUrl
                  "
                  :type="
                    attachmentType === 'pdf' ? 'application/pdf' : 'image/jpeg'
                  "
                  width="100%"
                  height="650"
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";

export default {
  name: "AttachmentsViewer",
  props: {
    attachmentUrl: {
      type: String || null,
      required: true,
    },
    attachmentType: {
      type: String,
      required: true,
    },
    showAttachments: {
      type: Boolean,
      default: false,
    },
    docTitle: {
      type: String,
      default: null,
    },
  },

  components: {
    Loader,
  },
  data() {
    return {
      create_error: null,
      loading: false,
    };
  },

  computed: {},
  methods: {
    close() {
      this.$emit("close");
    },
    getAttachmentUrl() {
      return `data:application/pdf;base64,${this.attachmentUrl}`;
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
